import React from "react";
import "./testimonials.scss";

const Testimonials = ({ quote, quotedby }) => {
    return (
        <p>
            <span className="material-symbols-outlined material-icons">
                record_voice_over
            </span>
            <span className="quote">{quote}</span>
            <span className="quotee">- {quotedby}</span>
        </p>
    );
};

export default Testimonials;